import React from 'react';
import { Box, Container, Card, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #004792 0%, #38A845 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card
          elevation={8}
          sx={{
            borderRadius: 4,
            textAlign: 'center',
            p: { xs: 4, md: 6 },
            bgcolor: 'white',
          }}
        >
          <CardContent>
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              Acesso Negado
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              Você não possui permissão para acessar esta página.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              sx={{ textTransform: 'none' }}
            >
              Voltar
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default Unauthorized;
